import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 16 16" focusable="false" fill="currentColor" aria-hidden="true"><g fillRule="nonzero" fill="none"><path d="M2.275 0C1.575 0 1 .55 1 1.25v13.475c0 .7.575 1.275 1.275 1.275h11.45c.7 0 1.275-.575 1.275-1.275v-9.65L10.275 0h-8Z" fill="#8384F4" /><path d="M8.929 12H4.6a.6.6 0 0 1-.6-.6V8.6a.6.6 0 0 1 .6-.6h4.337a.6.6 0 0 1 .6.602l-.008 2.8a.6.6 0 0 1-.6.598ZM11.887 11.933l-1.603-.993a.297.297 0 0 1-.144-.242V9.29a.297.297 0 0 1 .144-.242l1.603-.993a.077.077 0 0 1 .073-.004c.023.01.038.032.04.056v3.75a.066.066 0 0 1-.035.066.077.077 0 0 1-.078-.002v.011Z" fill="#FFF" /><path d="M10.275 0v3.65c0 .4.275 1.45 1.525 1.45H15L10.275 0Z" fill="#D7D7FF" /></g></svg>

const Video = React.forwardRef((props, ref) => {
  return (
    <IconBase name="video" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Video.displayName = 'IconVideo'

export default Video
